class RecommendedProducts extends HTMLElement {
    static ELEMENT_NAME = 'recommended-products'

    ids = {
        product: '',
        recommendationResults: 'recommended-products-results'
    }

    intent = 'related'
    limit = '5'

    constructor() {
        super()

        if (this.hasAttribute('product')) {
            this.ids.product = this.getAttribute('product')
        }

        if (this.hasAttribute('intent')) {
            this.intent = this.getAttribute('intent')
        }

        if (this.hasAttribute('limit')) {
            this.limit = this.getAttribute('limit')
        }

        this.showRecommendations()
    }

    /**
     * FETCH
     */

    async getHTMLRecommendedProducts(){
        try {
            const response = await fetch(`/recommendations/products?product_id=${this.ids.product}&intent=${this.intent}&section_id=${this.ids.recommendationResults}&limit=${this.limit}`)

            if (response.ok) {
                // all good!
                return response.text()
            } else {
                const error = new Error(response.status)

                throw error
            }

        } catch (error) {
            console.error('Error fetching recommended products:', error)
            throw error
        }
    }

    /**
     * FUNCTIONS
     */

    renderRecommendationsResults(resultsAsText) {
        const parsedHTML = new DOMParser()
            .parseFromString(resultsAsText, 'text/html')
            .querySelector(`#shopify-section-${this.ids.recommendationResults}`)

        this.innerHTML = parsedHTML.innerHTML
    }

    showRecommendations() {
        this.getHTMLRecommendedProducts().then(results => this.renderRecommendationsResults(results))
    }
}

customElements.define(RecommendedProducts.ELEMENT_NAME, RecommendedProducts);